module.exports = __webpack_public_path__ + "media/images/icon_photo_plus-1ee14b70ff7fa0b93b0abbfee1b1c22c.png";